import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonButton } from '../../Button/Button.definition';
import { chameleonSvg } from '../../Svg';
import { chameleonDataTableFilterBarV2 } from './definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTableFilterBarV2({ prefix }), chameleonButton({ prefix }), chameleonSvg({ prefix }));
}
